import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"

const styleSheet = theme => ({
  root: {
    margin: [theme.spacing.unit * 6, "auto"],
    width: "100%",

    [theme.breakpoints.down("xs")]: {
      margin: [theme.spacing.unit * 4, "auto"],
    },
  },

  responsive: {
    [theme.breakpoints.down("xs")]: {
      margin: 0,
    },
  },

  colorDefault: {
    backgroundColor: theme.palette.background.workspace,
  },

  colorPaper: {
    background: theme.palette.background.paper,
  },
})

function DocumentContainer({
  classes,
  className: classNameProp,
  children,
  color,
  responsive,
  title,

  ...otherProps
}) {
  const className = classnames(
    classes.root,
    {
      [classes.responsive]: responsive,
      [classes.colorDefault]: color === "default",
      [classes.colorPaper]: color === "paper",
    },
    classNameProp
  )

  return (
    <div className={className} {...otherProps}>
      {children}
      {title && (
        <Helmet>
          <title>{title}</title>
        </Helmet>
      )}
    </div>
  )
}

DocumentContainer.propTypes = {
  color: PropTypes.oneOf(["default", "paper"]),
  responsive: PropTypes.bool,
  title: PropTypes.string,
}

DocumentContainer.defaultProps = {
  color: "default",
}

import withStyles from "@material-ui/core/styles/withStyles"
import classnames from "classnames"

export default withStyles(styleSheet)(DocumentContainer)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-DocumentContainer/DocumentContainer.js